/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contactus_Secondaryaction2Inputs */

const en_contactus_secondaryaction2 = /** @type {(inputs: Contactus_Secondaryaction2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat with us`)
};

/**
* | output |
* | --- |
* | "Chat with us" |
*
* @param {Contactus_Secondaryaction2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const contactus_secondaryaction2 = /** @type {((inputs?: Contactus_Secondaryaction2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contactus_Secondaryaction2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contactus_secondaryaction2(inputs)
});
export { contactus_secondaryaction2 as "contactUs_secondaryAction" }